<template>
    <div class="d-flex flex-wrap mb-3">
        <v-btn
            class="mr-2 mb-2"
            :color="activeStatus === null ? 'primary' : ''"
            :outlined="activeStatus !== null"
            @click="setStatus(null)">
            All
        </v-btn>
        <v-btn
            class="mr-2 mb-2"
            color="blue"
            :outlined="activeStatus !== 0"
            :dark="activeStatus === 0"
            @click="setStatus(0)">
            In Progress
        </v-btn>
        <v-btn
            class="mr-2 mb-2"
            color="orange"
            :outlined="activeStatus !== 1"
            :dark="activeStatus === 1"
            @click="setStatus(1)">
            Review
        </v-btn>
        <v-btn
            class="mr-2 mb-2"
            color="teal"
            :outlined="activeStatus !== 2"
            :dark="activeStatus === 2"
            @click="setStatus(2)">
            Approved
        </v-btn>
        <v-btn
            class="mr-2 mb-2"
            color="indigo"
            :outlined="activeStatus !== 3"
            :dark="activeStatus === 3"
            @click="setStatus(3)">
            Sent
        </v-btn>
        <v-btn
            class="mr-2 mb-2"
            color="green"
            :outlined="activeStatus !== 4"
            :dark="activeStatus === 4"
            @click="setStatus(4)">
            Won
        </v-btn>
        <v-btn
            class="mr-2 mb-2"
            color="red"
            :outlined="activeStatus !== 5"
            :dark="activeStatus === 5"
            @click="setStatus(5)">
            Lost
        </v-btn>
        <v-btn
            class="mr-2 mb-2"
            color="amber"
            :outlined="activeStatus !== 6"
            :dark="activeStatus === 6"
            @click="setStatus(6)">
            Postponed
        </v-btn>
        <v-btn
            class="mr-2 mb-2"
            color="grey"
            :outlined="activeStatus !== 7"
            :dark="activeStatus === 7"
            @click="setStatus(7)">
            Abandoned
        </v-btn>
    </div>
</template>

<script>
export default {
    data() {
        return {
            activeStatus: null
        };
    },
    methods: {
        setStatus(status) {
            this.activeStatus = status;
            this.$emit('status-change', status);
        }
    }
};
</script>
